<section class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800/40">
  <div class="mb-3 flex items-center justify-between">
    <h2 class="text-lg font-semibold text-neutral-900 dark:text-white">Itens do pedido</h2>
  </div>

  <table class="table-auto w-full border-collapse">
    <thead>
      <tr class="border-b border-neutral-200 dark:border-neutral-700">
        <th style="width:100px" class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">SkuId</th>
        <th style="width:120px" class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">SkuRefId</th>
        <th class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">SKU</th>
        <th style="width:60px" class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Qtd</th>
        <th style="width:120px" class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Preço Original</th>
        <th style="width:140px" class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Ajustes</th>
        <th style="width:120px" class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Preço Final</th>
      </tr>
    </thead>
    <tbody>
      @for (p of items; track p.productId) {
        <tr class="border-b border-neutral-200 last:border-b-0 dark:border-neutral-700">
          <td class="p-2.5 align-top text-sm">
            <a [routerLink]="['/catalog/product', p.productId]" target="_blank"
               class="font-mono text-blue-600 underline decoration-dotted underline-offset-2 hover:decoration-solid hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300">
              {{ p.productId }}
            </a>
          </td>
          <td class="p-2.5 align-top text-sm">
            <a [routerLink]="['/catalog/product', p.productId]" target="_blank"
               class="font-mono text-blue-600 underline decoration-dotted underline-offset-2 hover:decoration-solid hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300">
              {{ p.refId }}
            </a>
          </td>
          <td class="p-2.5 align-top text-sm">
            <a [routerLink]="['/catalog/product', p.productId]" target="_blank"
               class="font-semibold text-blue-600 underline decoration-dotted underline-offset-2 hover:decoration-solid hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300">
              {{ p.name }}
            </a>
          </td>
          <td class="p-2.5 align-top font-mono text-sm text-neutral-900 dark:text-neutral-100">{{ p.quantity }}</td>
          <td class="p-2.5 align-top font-mono text-sm text-neutral-900 dark:text-neutral-100">{{ formatCents(p.price) }}</td>
          <td class="p-2.5 align-top text-sm">
            @if (p.adjustments.length > 0) {
              <button type="button"
                (click)="openAdjustments(p)"
                class="inline-flex cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0 font-mono font-semibold"
                [ngClass]="{
                  'text-emerald-500 dark:text-emerald-400': totalAdjustments(p) < 0,
                  'text-rose-500 dark:text-rose-400': totalAdjustments(p) > 0,
                  'text-neutral-500 dark:text-neutral-400': totalAdjustments(p) === 0
                }">
                <span class="opacity-60">ⓘ</span>
                {{ formatAdjustment(totalAdjustments(p)) }}
              </button>
            } @else {
              <span class="font-mono text-neutral-500 dark:text-neutral-400">—</span>
            }
          </td>
          <td class="p-2.5 align-top font-mono text-sm font-bold text-neutral-900 dark:text-neutral-100">{{ formatCents(p.sellingPrice) }}</td>
        </tr>
      }
    </tbody>
  </table>
</section>

<app-adjustments-modal [item]="selectedItem()" [open]="modalOpen()" (closed)="closeModal()" />
